/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UtenteEsternoEditDto } from '../../models/utente-esterno-edit-dto';

export interface ApiAuthUtenteEsternoEditGet$Params {
    /**
     * Id dell'utente per cui caricare i dati
     */
    utenteId: number;
}

export function apiAuthUtenteEsternoEditGet(
    http: HttpClient,
    rootUrl: string,
    params: ApiAuthUtenteEsternoEditGet$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<UtenteEsternoEditDto>> {
    const rb = new RequestBuilder(rootUrl, apiAuthUtenteEsternoEditGet.PATH, 'get');
    if (params) {
        rb.query('utenteId', params.utenteId, {});
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<UtenteEsternoEditDto>;
        }),
    );
}

apiAuthUtenteEsternoEditGet.PATH = '/api/auth/utente-esterno-edit';
